let menuToggler = document.getElementById('menuToggler');
let navbar = document.getElementById('mainMenu');
let body = document.getElementsByTagName('body')[0];

menuToggler.addEventListener("click", () => {
    menuToggler.classList.toggle('is-active');
    navbar.classList.toggle('activated');
    body.classList.toggle('menu-on');
});
